import { render } from "./TinyTag.vue?vue&type=template&id=3bd53c66&scoped=true&lang=pug"
import script from "./TinyTag.vue?vue&type=script&lang=js"
export * from "./TinyTag.vue?vue&type=script&lang=js"

import "./TinyTag.vue?vue&type=style&index=0&id=3bd53c66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd53c66"]])

export default __exports__